export default "__VITE_ASSET__DyjRpsiU__"